export default __webpack_public_path__ + "assets/images/KTMLogo.f6cf227481f879776b4984bf2bbd7382.png";